import React from 'react';

interface BatchProcessingIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const BatchProcessingIcon: React.FC<BatchProcessingIconProps> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <path
        clipRule="evenodd"
        d="M7.60449 4.16667C7.60449 3.76396 7.93095 3.4375 8.33366 3.4375H9.16699C9.5697 3.4375 9.89616 3.76396 9.89616 4.16667V8.33333C9.89616 8.73604 9.5697 9.0625 9.16699 9.0625C8.76428 9.0625 8.43783 8.73604 8.43783 8.33333V4.89583H8.33366C7.93095 4.89583 7.60449 4.56937 7.60449 4.16667ZM13.4378 11.6667C13.4378 11.264 13.7643 10.9375 14.167 10.9375H15.0003C15.403 10.9375 15.7295 11.264 15.7295 11.6667V15.8333C15.7295 16.236 15.403 16.5625 15.0003 16.5625C14.5976 16.5625 14.2712 16.236 14.2712 15.8333V12.3958H14.167C13.7643 12.3958 13.4378 12.0694 13.4378 11.6667Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M13.2288 4.89583V7.60417H14.2705V4.89583H13.2288ZM12.1061 3.77311C12.321 3.55822 12.6124 3.4375 12.9163 3.4375H14.583C14.8869 3.4375 15.1783 3.55822 15.3932 3.77311C15.6081 3.98799 15.7288 4.27944 15.7288 4.58333V7.91667C15.7288 8.22056 15.6081 8.51201 15.3932 8.72689C15.1783 8.94178 14.8869 9.0625 14.583 9.0625H12.9163C12.6124 9.0625 12.321 8.94178 12.1061 8.72689C11.8912 8.51201 11.7705 8.22056 11.7705 7.91667V4.58333C11.7705 4.27944 11.8912 3.98799 12.1061 3.77311Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.06283 12.3958V15.1042H10.1045V12.3958H9.06283ZM7.9401 11.2731C8.15499 11.0582 8.44643 10.9375 8.75033 10.9375H10.417C10.7209 10.9375 11.0123 11.0582 11.2272 11.2731C11.4421 11.488 11.5628 11.7794 11.5628 12.0833V15.4167C11.5628 15.7206 11.4421 16.012 11.2272 16.2269C11.0123 16.4418 10.7209 16.5625 10.417 16.5625H8.75033C8.44643 16.5625 8.15499 16.4418 7.9401 16.2269C7.72521 16.012 7.60449 15.7206 7.60449 15.4167V12.0833C7.60449 11.7794 7.72521 11.488 7.9401 11.2731Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.27051 8.33329C4.27051 7.93059 4.59697 7.60413 4.99967 7.60413H5.00801C5.41072 7.60413 5.73717 7.93059 5.73717 8.33329C5.73717 8.736 5.41072 9.06246 5.00801 9.06246H4.99967C4.59697 9.06246 4.27051 8.736 4.27051 8.33329ZM4.27051 15.8333C4.27051 15.4306 4.59697 15.1041 4.99967 15.1041H5.00801C5.41072 15.1041 5.73717 15.4306 5.73717 15.8333C5.73717 16.236 5.41072 16.5625 5.00801 16.5625H4.99967C4.59697 16.5625 4.27051 16.236 4.27051 15.8333Z"
        fill="#B5BCC4"
        fillRule="evenodd"
      />
    </svg>
  );
};
